module.exports = __webpack_public_path__ + "static/media/staricon.b30026ec.svg";